module.exports = __webpack_public_path__ + "assets/ziyuan_1.bf9d49db.svg";